<script setup lang="ts">
import { CategoryListMdw } from '~/lib/services/middleware/middleware.dtos'

defineProps<{
  categories: CategoryListMdw[]
}>()

const { t } = useLocale()
const { staticCategoryRoute } = useMcdRoutes()
</script>

<template>
  <h1 class="collapse h-0 w-0">{{ t('productDetailStatic.menu') }}</h1>
  <section
    class="mx-auto my-10 grid w-full grid-cols-2 gap-5 p-4 sm:w-[80%] sm:grid-cols-3 md:grid-cols-4 md:gap-10 lg:w-[60%]"
  >
    <NuxtLink
      v-for="category in categories"
      :key="category._id"
      :to="staticCategoryRoute(category.name)"
      class="hover-scale flex flex-col items-center justify-center gap-2"
    >
      <ImageResolver
        class="my-2 h-auto w-20"
        loading="lazy"
        :url="category.image"
        :alt="`${category.name} image`"
      />
      <h2 class="min-h-[64px] text-center text-xl md:text-2xl">{{ category.name }}</h2>
    </NuxtLink>
  </section>
</template>
